<template>
    <div class="modal-content" ref="container">
        <div class="modal-header">
            <h2 class="modal-title">{{ status != "sent" ? "Confirm Resend" : "Notification resent" }}</h2>
            <button type="button" class="close icon icon-close" aria-hidden="true" @click="close" autofocus :disabled="status == 'sending'"><span class="sr-only">Close</span></button>
        </div>
        <div class="modal-body">
            <template v-if="status == 'pending'">
                <div v-if="messages.length > 0" class="alert alert-danger">
                    <span class="sr-only">Validation:</span>
                    <ul>
                        <li v-for="message in messages">{{ message }}</li>
                    </ul>
                </div>
                <p v-if="type == 'email'">Are you sure you want to resend this email?</p>
                <p v-if="type == 'sms'">Are you sure you want to resend this text message?</p>
                <div v-if="commentRequired" class="form-group">
                    <label for="ReturnComment">Returning with comment:</label>
                    <textarea row="3" v-model="comment" id="returnComment" class="form-control" placeholder="A comment is required" />
                </div>
            </template>
            <div v-else-if="status == 'sending'">
                <LoadingWheel :width="100" />
            </div>
            <template v-else-if="status == 'sent'">
                <span class="action-success-icon icon icon-check"></span>
                <p v-if="type == 'email'" class="action-success-text">Email sent successfully.</p>
                <p v-if="type == 'sms'" class="action-success-text">Text message sent successfully.</p>
            </template>
        </div>
        <div class="modal-footer">
            <template v-if="status != 'sent'">
                <button id="resendBtn" class="btn btn-primary" @click="submit" :disabled="status == 'sending'">Resend</button>
                <button id="cancelBtn" class="btn btn-outline-secondary" @click="$emit('close')" :disabled="status == 'sending'">Cancel</button>
            </template>
            <a v-else class="btn btn-outline-secondary" @click.prevent="close">Close</a>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, SetupContext } from "vue";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
type Props = {
    resendFunction: (comment: string) => Promise<{ success: boolean; messages: string[] }>; // TODO import type
    commentRequired: boolean;
    type: string;
} & DialogProps;
export default defineComponent({
    props: ["resendFunction", "commentRequired", "type", "triggerElement"],
    components: {
        LoadingWheel,
    },
    setup(props: Props, { emit }: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef, props);
        const status = ref("pending" as "pending" | "sending" | "sent");
        const messages = ref([] as string[]);
        const comment = ref(undefined as undefined | string);

        const submit = async () => {
            status.value = "sending";
            const result = await props.resendFunction(comment.value!);
            if (result.success) {
                status.value = "sent";
            } else {
                status.value = "pending";
                messages.value = result.messages;
            }
        };

        return {
            container: containerRef,
            status,
            messages,
            submit,
            comment,

            close: () => emit("close"),
        };
    },
});
</script>
